import { cn } from "@/utils/utils";
import "./NextButton.css";

interface Props {
  text: string;
  onClick: () => void;
  buttonDisabled?: boolean;
  buttonColor?: string;
  extraClassNames?: string;
}

const NextButton = ({
  text,
  onClick,
  buttonDisabled,
  buttonColor,
  extraClassNames,
}: Props) => {
  return (
    <button
      className={cn(
        "next-button outline-none font-light text-sm",
        buttonDisabled ? "opacity-20 cursor-not-allowed" : "",
        extraClassNames
      )}
      onClick={() => (buttonDisabled ? null : onClick())}
      style={{
        backgroundColor:
          buttonColor && buttonColor !== "" ? buttonColor : "black",
      }}
    >
      {text}
    </button>
  );
};

export default NextButton;
